$(document).on('click', ".js-go-cart-quantity-plus" , function() {
  $.getJSON("/cart.js", function (json) {
    $('#cart-length').html((json.item_count + 1));
  });
});

$(document).on('click', ".js-go-cart-quantity-minus" , function() {  
  $.getJSON("/cart.js", function (json) {
    $('#cart-length').html((json.item_count - 1));
  });
});


// $(document).on('click', ".adjust-plus" , function() {
//   $.getJSON("/cart.js", function (json) {
//     $('#cart-length').html((json.item_count + 1));
//      $(".js-go-cart-counter").html((json.item_count + 1));
//   });
// });

// $(document).on('click', ".adjust-minus" , function() {  
//   $.getJSON("/cart.js", function (json) {
//     $('#cart-length').html((json.item_count - 1));
//     $(".js-go-cart-counter").html((json.item_count - 1));
//   });
// });




$('.js-go-cart-add-to-cart').click(function() {
     $.getJSON("/cart.js", function (json) {
      $('#cart-length').html((json.item_count + 1));
  });
});

